import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './SmallNotice.css';

const cx = classnames.bind(styles);

function SmallNotice({
    className,
    iconName,
    description,
    withBorder,
    withBackground
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className),
        withBorder,
        withBackground
    });
    const iconClasses =  cx({
        icon: true,
        [iconName]: Boolean(iconName)
    });

    return (
        <div className={classes}>
            <Icon
                name={iconName}
                className={iconClasses}
            />
            <p className={styles.description}>
                {description}
            </p>
        </div>
    );
}

SmallNotice.propTypes = {
    className: PropTypes.string,
    iconName: PropTypes.string.isRequired,
    description: PropTypes.any.isRequired,
    withBorder: PropTypes.bool,
    withBackground: PropTypes.bool
};

SmallNotice.defaultProps = {
    className: '',
    withBorder: false,
    withBackground: false
};

export {
    SmallNotice
};
